<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2Box max-w-1400">
        <img :src="importedImg2" alt="" class="imgItem2" />
        <div class="clickBox1" @click="gotoPage1"></div>
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
      <div class="img3Box max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem3" />
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5Box max-w-1400">
        <img :src="bannerHeaderImg" alt="" class="imgItem3" />
        <el-carousel
          indicator-position="outside"
          height="400px"
          trigger="click"
        >
          <el-carousel-item v-for="item in bannerList" :key="item.label">
            <img :src="item.url" alt="" class="imgItem5" />
            <div class="clickBox2" @click="gotoPage2(item.pagePath)"></div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="imgBox4 min-w-1400">
      <div class="img4Box max-w-1400">
        <img :src="importedImg4" alt="" class="imgItem4" />
      </div>
    </div>
    <div class="imgBox6 min-w-1400">
      <div class="img6Box max-w-1400">
        <!-- <img :src="importedImg6" alt="" class="imgItem6" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/easycommuservicessas/components/img/1_1.png";
import importedImg2 from "@/page/easycommuservicessas/components/img/1_2.png";
import importedImg3 from "@/page/easycommuservicessas/components/img/1_3.png";
import importedImg4 from "@/page/easycommuservicessas/components/img/1_4.png";
import bannerHeaderImg from "@/page/easycommuservicessas/components/img/banner_header.png";
import bannerImg1 from "@/page/easycommuservicessas/components/img/banner_1.png";
import bannerImg2 from "@/page/easycommuservicessas/components/img/banner_2.png";
import bannerImg3 from "@/page/easycommuservicessas/components/img/banner_3.png";
import bannerImg4 from "@/page/easycommuservicessas/components/img/banner_4.png";
import bannerImg5 from "@/page/easycommuservicessas/components/img/banner_5.png";
// import importedImg5 from "@/page/easycommuservicessas/components/img/1_5.png";
// import importedImg6 from "@/page/easycommuservicessas/components/img/1_6.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      bannerHeaderImg: bannerHeaderImg,
      bannerList: [
        {
          label: "Industria logística",
          url: bannerImg1,
          pagePath: "/introduce5",
        },
        {
          label: "Industria educativa",
          url: bannerImg2,
          pagePath: "/introduce4",
        },
        {
          label: "Industria automotriz",
          url: bannerImg3,
          pagePath: "/introduce1",
        },
        {
          label: "Industria del personal",
          url: bannerImg4,
          pagePath: "/introduce2",
        },
        {
          label: "Industria inmobiliaria",
          url: bannerImg5,
          pagePath: "/introduce3",
        },
      ],
      // importedImg5: importedImg5,
      // importedImg6: importedImg6,
      altText: "图片",
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    gotoPage1() {
      this.$router.push({ path: "/about" });
    },
    gotoPage2(path) {
      this.$router.push({ path });
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7 {
  width: 100%;
  margin: 0;
}
.img2Box,
.img3Box,
.img4Box,
.img5Box {
  padding: 0 220px;
}
.img2Box {
  margin: 100px 0;
}
.img5Box {
  margin-top: 50px;
}
.img4Box {
  margin: 80px 0;
}
.imgItem5 {
  width: 100%;
  height: 100%;
}
.img2Box {
  position: relative;
}
.clickBox1 {
  position: absolute;
  background: transparent;
  width: 302px;
  height: 71px;
  top: 74.5%;
  left: 15.5%;
  cursor: pointer;
  /* border: 1px solid red; */
}
.img5Box {
  position: relative;
}
.clickBox2 {
  position: absolute;
  background: transparent;
  width: 120px;
  height: 30px;
  top: 74.5%;
  left: 3.5%;
  cursor: pointer;
  /* border: 1px solid red; */
}
/* 滚动窗口底部的指示器 */
.el-carousel ::v-deep .el-carousel__indicators--outside li button {
  /* height: 30px; */
  width: 175px;
  background: none;
  font-size: 16px;
  /* color: #2B6BCC; */
  /* border-bottom: 1px solid #2B6BCC; */
  /* margin: auto 15px; */
}
.el-carousel
  ::v-deep
  .el-carousel__indicators--outside
  li:nth-child(1)
  button::after {
  content: "Industria logística";
  /* color: #888888; */
}

.el-carousel
  ::v-deep
  .el-carousel__indicators--outside
  li:nth-child(2)
  button::after {
  content: "Industria educativa";
}

.el-carousel
  ::v-deep
  .el-carousel__indicators--outside
  li:nth-child(3)
  button::after {
  content: "Industria automotriz";
}
.el-carousel
  ::v-deep
  .el-carousel__indicators--outside
  li:nth-child(4)
  button::after {
  content: "Industria del personal";
}

.el-carousel
  ::v-deep
  .el-carousel__indicators--outside
  li:nth-child(5)
  button::after {
  content: "Industria inmobiliaria";
}
</style>
